import { useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import CategoryBreadcrumb from '@/components/feature/CategoryBreadcrumb';
import { categories } from '@/mocks/categories';
import { getArticlesByCategory } from '@/mocks/articles';
import { Link } from 'react-router-dom';

export default function CategoryPage() {
  const { slug } = useParams();
  const category = categories.find(c => c.slug === slug);
  const articles = category ? getArticlesByCategory(category.slug) : [];

  return (
    <>
      <Navbar />
      <main>
        {/* Hero Header for Category */}
        <section className="pt-16 min-h-[260px] md:min-h-[320px] flex items-center bg-background-100 border-b border-background-200">
          <div className="px-4 md:px-6 w-full max-w-7xl mx-auto">
            <div className="mb-4">
              <CategoryBreadcrumb categorySlug={slug} />
            </div>
            <h1 className="text-3xl md:text-5xl font-bold font-heading text-foreground-900 mb-3">
              {category?.name || '分类'}
            </h1>
            <p className="text-sm md:text-base text-foreground-500 max-w-lg">
              {category?.description || '浏览该分类下的全部爆料资讯'}
            </p>
          </div>
        </section>

        {/* Category Tabs */}
        <section className="sticky top-16 md:top-[72px] z-40 bg-background-50 border-b border-background-200">
          <div className="px-4 md:px-6 max-w-7xl mx-auto">
            <div className="flex items-center gap-1 py-3 overflow-x-auto">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`whitespace-nowrap px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 ${
                    cat.slug === slug
                      ? 'bg-primary-600 text-background-50'
                      : 'text-foreground-600 hover:bg-background-100 hover:text-foreground-900'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Article List */}
        <section className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
          <div className="max-w-7xl mx-auto">
            {articles.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
                {articles.map((article) => (
                  <article key={article.id} className="group rounded-lg overflow-hidden bg-background-50 border border-background-200/70 transition-all duration-300 hover:scale-[1.02]">
                    <Link to={`/article/${article.id}`} className="block relative aspect-[4/3] overflow-hidden">
                      <img
                        src={article.coverImage}
                        alt={article.title}
                        title={article.title}
                        className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                        loading="lazy"
                      />
                      <div className="absolute top-3 right-3">
                        <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-accent-500/90 text-background-50 text-xs font-medium backdrop-blur-sm">
                          <i className="ri-fire-line text-[10px]"></i>
                          {article.hotIndex}°
                        </span>
                      </div>
                    </Link>
                    <div className="p-4">
                      <Link to={`/category/${article.categorySlug}`} className="inline-block text-xs text-primary-600 font-medium mb-2 hover:text-primary-700">
                        {article.category}
                      </Link>
                      <Link to={`/article/${article.id}`}>
                        <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 line-clamp-2 leading-snug group-hover:text-primary-700 transition-colors duration-200">
                          {article.title}
                        </h3>
                      </Link>
                      <p className="text-xs text-foreground-500 line-clamp-2 mb-3 leading-relaxed">{article.excerpt}</p>
                      <div className="flex items-center justify-between text-xs text-foreground-400">
                        <span className="flex items-center gap-1">
                          <i className="ri-eye-line"></i>
                          {article.views > 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views}
                        </span>
                        <span className="flex items-center gap-1">
                          <i className="ri-chat-3-line"></i>
                          {article.comments}
                        </span>
                        <span className="flex items-center gap-1">
                          <i className="ri-time-line"></i>
                          {article.publishedAt.slice(5)}
                        </span>
                      </div>
                    </div>
                  </article>
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <i className="ri-inbox-line text-4xl text-foreground-300 mb-4 block"></i>
                <p className="text-foreground-500">该分类暂无内容</p>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />

      {category && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'CollectionPage',
              name: category.name,
              description: category.description,
              url: `https://4xhyp.com/category/${category.slug}`,
              mainEntity: {
                '@type': 'ItemList',
                itemListElement: articles.map((a, i) => ({
                  '@type': 'ListItem',
                  position: i + 1,
                  url: `https://4xhyp.com/article/${a.id}`,
                  name: a.title,
                })),
              },
            }),
          }}
        />
      )}
    </>
  );
}
